







































import PieChartCard from "@/components/analytics/PieChartCard.vue";
import MyDamageDetailSideCard from "@/components/report/user/MyDamageDetailSideCard.vue";
import Notifications from "@/components/thg/Notifications.vue";
import TableWrapper, { IControlElements } from "@/components/utility/TableWrapper.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import {
  MrfiktivInvoicePopulatedViewModelGen,
  MrfiktivInvoiceViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { AnalyticsFleetModule } from "@/store/modules/fleet/analytics-fleet.store";
import { InvoiceFleetModule } from "@/store/modules/fleet/invoice-fleet.store";
import { ManagerFleetModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { downloadUrlFromRemoteOrigin } from "@/lib/utility/downloadFileFunc";
import invoiceFleetService from "@/services/mrfiktiv/services/fleet/invoiceFleetService";

@Component({
  components: {
    LayoutReportWithBanner,
    Notifications,
    TableWrapper,
    MyDamageDetailSideCard,
    PieChartCard
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetVehicleView extends Vue {
  readonly formatCurrency = formatCurrency;

  isLoading = false;
  selectedId: string | null = null;

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetHomeView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: this.$t("report.thgBillingOverview.title"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetInvoiceView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get fleetIds() {
    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId).map(p => p.fleetId);
  }

  get fleetId() {
    return ManagerFleetModule.current?.id;
  }

  get damageTypeSubtotalData() {
    return AnalyticsFleetModule.damageTypeSubtotalOutboundData;
  }

  get items() {
    return InvoiceFleetModule.all;
  }

  get i18n() {
    return this.$t("objects.invoice");
  }

  get headers() {
    return [
      {
        text: this.i18n["created"],
        align: "left",
        width: 120,
        value: "timestamp.created"
      },
      {
        text: this.i18n["number"],
        align: "left",
        value: "number"
      },
      {
        text: this.i18n["date"],
        align: "left",
        type: Date,
        value: "date"
      },
      {
        text: this.i18n["due"],
        align: "left",
        type: Date,
        value: "due"
      },
      {
        text: this.i18n["subTotal"],
        align: "left",
        value: "subTotal"
      },
      { text: "", value: "controls", align: "right", sortable: false }
    ];
  }

  get controlElements(): IControlElements[] {
    const controlElements: IControlElements[] = [
      {
        icon: "mdi-download",
        text: this.$t("download").toString(),
        action: async (selectedItem: MrfiktivInvoicePopulatedViewModelGen) => {
          if (!selectedItem.fleetId) {
            return;
          }

          const invoice = await invoiceFleetService.findOne(
            selectedItem.partnerId,
            selectedItem.fleetId,
            selectedItem.id
          );

          if (!invoice.data.document?.url) {
            return;
          }

          await downloadUrlFromRemoteOrigin(invoice.data.document.url, `${selectedItem.number}.pdf`);
        }
      }
    ];

    return controlElements;
  }

  async mounted() {
    await this.load();
  }

  async load() {
    if (!this.fleetId) {
      return;
    }

    this.isLoading = true;

    try {
      await InvoiceFleetModule.getAll({ partnerId: this.partnerId, fleetId: this.fleetId });
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }

  async openDetail(item: MrfiktivInvoiceViewModelGen) {
    this.$log.debug(item);
    this.isLoading = true;

    try {
      const invoice = await InvoiceFleetModule.getOne({
        partnerId: this.partnerId,
        fleetId: this.fleetIds[0],
        id: item.id
      });
      this.selectedId = invoice.id;
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }
}
